// Coerces a raw current_account_id string to a number, guarding against
// non-numeric values so a malformed id becomes undefined rather than NaN.
export function parseAccountId(
  value: string | null | undefined,
): number | undefined {
  if (!value) return undefined;
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? undefined : parsed;
}
